import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { partnerBillingStatus } from "../lib/api";

export default function SalonBillingReturn() {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const cancelled = location.pathname.endsWith("/cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(cancelled ? "cancelled" : "checking");

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    const tick = async () => {
      try {
        const r = await partnerBillingStatus(sessionId);
        if (r.status === "active") { setStatus("active"); return; }
      } catch (error) { console.warn("Partner billing status check failed; retrying.", error); }
      if (++tries < 6) setTimeout(tick, 2000);
      else setStatus("pending");
    };
    tick();
  }, [sessionId, cancelled]);

  return (
    <div className="min-h-screen bg-bone pt-14 md:pt-16 flex items-center" data-testid="salon-billing-return">
      <div className="max-w-md mx-auto px-6 text-center">
        {status === "checking" && <><Loader2 className="animate-spin mx-auto text-espresso" size={28} /><p className="mt-5 text-sm text-ink/60">Confirming your free trial…</p></>}
        {status === "active" && <>
          <CheckCircle2 className="mx-auto text-burgundy" size={40} />
          <h1 className="mt-5 font-serif text-4xl text-ink">You're in.</h1>
          <p className="mt-3 text-sm text-ink/60">Card saved — no charge before 7 April 2027 for pre-launch partners. Two launch months are on us.</p>
        </>}
        {status === "pending" && <>
          <CheckCircle2 className="mx-auto text-burgundy" size={40} />
          <h1 className="mt-5 font-serif text-4xl text-ink">Almost there.</h1>
          <p className="mt-3 text-sm text-ink/60">We're still confirming with Stripe — your dashboard will update shortly.</p>
        </>}
        {status === "cancelled" && <>
          <XCircle className="mx-auto text-mocha" size={40} />
          <h1 className="mt-5 font-serif text-4xl text-ink">No worries.</h1>
          <p className="mt-3 text-sm text-ink/60">You weren't charged. You can set up your membership anytime.</p>
        </>}
        <button type="button" onClick={() => navigate("/salon/admin")} className="mt-7 rounded-full bg-espresso text-bone px-6 py-3 text-sm hover:bg-ink transition-colors" data-testid="salon-billing-return-dashboard">Back to dashboard</button>
      </div>
    </div>
  );
}
